import {
  Heading,
  Text,
  Container,
  Col,
  Stack,
  Visible
} from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'
import { Icon } from '../../components/Icon'

const CARD_LIST = [
  {
    title: 'Cadastre-se',
    description: 'Faça seu cadastro e escolha suas preferências',
    icon: 'checkbox'
  },
  {
    title: 'Junte Pontos',
    description:
      'Depois do cadastro  a cada R$ 1,00 em compras você ganha 1 Ponto. ',
    icon: 'points'
  },
  {
    title: 'Aproveite',
    description:
      'Receba cupons diariamente e troque seus pontos por vantagens.',
    icon: 'enjoy'
  }
]

const Section = () => {
  return (
    <S.Section>
      <Container>
        <Col size={{ giga: 10 }} offset={{ giga: 1 }}>
          <Stack spacing="bit">
            <Heading size="tera" noMargin>
              Para participar é fácil…
            </Heading>
            <S.Description size="kilo" noMargin>
              Não demora nem 5 min (é sério, nós contamos)
            </S.Description>
          </Stack>

          <S.ContainerContent>
            <S.CardList>
              {CARD_LIST.map((card, index) => (
                <S.CardItem key={index}>
                  <S.Card>
                    <S.CardIcon>
                      <Icon name={card.icon} />
                    </S.CardIcon>
                    <Stack spacing="bit">
                      <S.CardTitle size="mega" noMargin>
                        {card.title}
                      </S.CardTitle>
                      <S.CardDescription size="kilo">
                        {card.description}
                      </S.CardDescription>
                    </Stack>
                  </S.Card>
                </S.CardItem>
              ))}
            </S.CardList>

            <Visible giga tera>
              <S.ContainerPhone>
                <S.ImgPhone
                  src={`${
                    window && window.env.assetHost
                  }assets/images/lmcv/landing-page-2019/cellphone.png`}
                />
              </S.ContainerPhone>
            </Visible>
          </S.ContainerContent>
        </Col>
      </Container>
    </S.Section>
  )
}

export default Section
